import Components from "../components";
import * as Turbo from "@hotwired/turbo"
import Rails from '@rails/ujs';

class DropdownWithSearch extends Components.Base {
  initialize() {
    this.$input = this.$el.find('.dropdown-search input');
  }

  bind() {
    this.on('shown.bs.dropdown', () => this.focus());
    this.on('hidden.bs.dropdown', () => this.reset());
    this.$input.on('keyup.dropdown-with-search', e => this.key(e));
  }

  unbind() {
    this.$input.off('keyup.dropdown-with-search');
  }

  focus() {
    this.$input.focus();
  }

  reset() {
    this.$input.val('');
    this.$input.blur();
    this.$el
      .find('.dropdown-item')
      .removeClass('d-none')
      .removeClass('active');
  }

  key(e) {
    if (e.keyCode === 27) {
      // Escape
      this.$el.find('.dropdown-menu').dropdown('toggle');
    } else if (e.keyCode === 13) {
      // Enter
      const results = this.$el.find('.dropdown-item.active').not('.d-none');
      if (results.length === 1) {
        if (
          results[0].hasAttribute('data-remote') ||
          results[0].hasAttribute('data-click')
        ) {
          Rails.fire(results[0], "click");
        } else {
          Turbo.visit(results[0].href);
        }
      }
    } else if (e.keyCode === 40) {
      // Down arrow
      this.activateNext();
    } else if (e.keyCode === 38) {
      // up arrow
      this.activatePrevious();
    } else {
      this.$el.find('.dropdown-item').removeClass('active');
      this.search();
      this.activateNext();
    }
  }

  activateNext() {
    const active = this.$el.find('.dropdown-item.active');
    if (active.length > 0) {
      const next = $(active)
        .nextAll('.dropdown-item')
        .not('.d-none')
        .first();

      if (next.length > 0) {
        next.addClass('active');
        $(active).removeClass('active');
      }
    } else {
      const results = this.$el.find('.dropdown-item').not('.d-none');
      $(results[0]).addClass('active');
    }
  }

  activatePrevious() {
    const active = this.$el.find('.dropdown-item.active');
    if (active.length > 0) {
      const prev = $(active)
        .prevAll('.dropdown-item')
        .not('.d-none')
        .first();
      if (prev.length > 0) {
        prev.addClass('active');
        $(active).removeClass('active');
      }
    }
  }

  search() {
    const v = this.$input.val();
    const pattern = new RegExp(v, 'i');
    this.$el.find('.dropdown-item').each((i, item) => {
      if (pattern.test(item.getAttribute('data-search'))) {
        $(item).removeClass('d-none');
      } else {
        $(item).addClass('d-none');
      }
    });
  }
}

Components.collection.register({
  selector: '.c-dropdown-with-search',
  klass: DropdownWithSearch,
});
